<template>
	<div class="infor-t clearfix">
		
		<div class="fl infor-t-l">{{label}}<span v-if="subtitle" class="font-remak">：{{subtitle}}</span> <span class="yaer" v-if="subtitle&&year!=null">{{ year }}年度</span> </div>
		<div class="fr infor-t-r" @click="changeinfo()" v-show="ischage">
			<img :src="img" alt="" />

			<span>{{sublabel}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: "AllHeader",
		props: {
			year:{
				type: String,
				default: null
			},
			label: {
				type: String,
				default: '标题'
			},
			img: {
				type: String,
				default: '../../assets/yan.png'
			},
			sublabel: {
				type: String,
				default: '标题'
			},
			subtitle: {
				type: String,
				default: ''
			},
			ischage: {
				// type: Boolean,
				// default: false
			}
		},
		data() {
			return {}
		},
		methods: {
			changeinfo() {
				this.$emit('getvalue')
			}
		}
	}
</script>

<style lang="less" scoped>
	.infor {
		width: 858px;
		padding: 0px 30px;
		background: #fff;
		border-radius: 6px;
		margin-left: 14px;

		&-t {
			// padding: 14px;
			padding-top: 14px;
			border-bottom: 1px solid #d4dbdd;

			&-l {
				font-size: 28px;
				color: #181e23;
				display: inline-block;
				padding-bottom: 14px;
				font-weight: bold;
				border-bottom: 2px solid #194abe;
			}

			&-r {
				width: 104px;
				height: 31px;
				border: 1px solid #7C828A;
				background: #194ABE;
				color: #FFFFFF;
				border-radius: 5px;
				opacity: 1;
				overflow: hidden;
				display: table-cell;
				line-height: 31px;
				cursor: pointer;

				img {
					vertical-align: middle;
				}

				span {
					font-size: 14px;
				}
			}
		}

		&-c {
			text-align: justify;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			line-height: 32px;
			color: #565656;
			padding: 10px 0px;
		}

		&-img {
			text-align: center;
			padding: 24px 0px 40px 0px;
		}
	}

	.font-remak {
		color: #194ABE;
	}
	.yaer{
		display: inline-block;
		width: 86px;
		height: 24px;
		background: #1ABF98;
		opacity: 1;
		border-radius: 12px;
		color: white;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		line-height: 24px;
		color: #FFFFFF;
	}
</style>
